import { IoClose } from 'react-icons/io5';
import { convertQueryObjToString, removeChildFilter, removeFilterOnDemand } from '../helper';
import { Flex } from 'antd';
import styles from './index.module.scss';

const FilterChips = ({
  location,
  navigate,
  selectedVal,
  setSelectedVal,
  baseList,
  setPageNumber,
  chipFilters,
  searchKey,
  searchValue,
  chipTitle,
}) => {
  const setSlugAsKey = baseList?.find((l) => l?.key === searchKey)?.setSlugAsKey;

  const onClose = () => {
    const obj = { ...chipFilters };
    setSelectedVal(selectedVal?.filter((item) => item.id !== toNumber(searchValue)));
    removeChildFilter(baseList, searchKey, obj, searchValue, setSlugAsKey);
    removeFilterOnDemand(obj, searchKey);
    setPageNumber(1);
    navigate({
      pathname: location.pathname,
      search: convertQueryObjToString({ ...obj }),
    });
  };

  return (
    <>
      <Flex align="center" gap={6} className={styles.filterChip} key={chipTitle}>
        <div>{chipTitle}</div>
        <IoClose size={14} color="var(--gray-300)" className="cursorPointer" role="button" onClick={onClose} />
      </Flex>
    </>
  );
};

export default FilterChips;
